import styled from "styled-components";
import { Button, colors } from "@streeteasy/design-system";
import { Body } from "@streeteasy/design-system/typography";

const { BRAND, GRAY_LIGHT, WHITE } = colors;

export const MWebVoucherBadgeContainer = styled.div`
  align-items: center;
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  display: block;
  margin-bottom: 16px;
  padding: 16px 20px;
  text-align: center;
  width: 100%;
`;

export const MWebVoucherBadgeText = styled(Body).attrs({})`
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0px;

  @media screen and (min-width: 375px) {
    white-space: nowrap;
  }

  @media screen and (max-width: 374px) {
    white-space: initial;
  }
`;

export const MWebVoucherButton = styled(Button).attrs({})`
  background: none;
  border: none;
  color: ${BRAND};
  height: 100%;
  min-width: auto;
  padding: 6px 0 0 0;

  &:hover {
    background-color: ${WHITE};
  }
`;
